import { Button, SpinningLoader } from 'common-components'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import styled from 'styled-components'
import { premiumButtonStyles } from 'containers/SubSidebar/styled'

export const Footer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding-top: 8px;
  border-top: 1px solid ${COLORS.borderColor};
  padding: 20px 16px 12px;
  z-index: 1;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    background-color: ${COLORS.white};
    position: sticky;
    bottom: 0;
  }
`

export const GenerateButton = styled(Button)<{ $isPremium: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  ${premiumButtonStyles}
`

export const SpinningLoaderWrapper = styled(SpinningLoader)<{
  $isVisible: boolean
}>`
  width: 16px;
  height: 16px;
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
`

export const CreditsBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

export const ThunderIcon = styled.img`
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
`
